export default __webpack_public_path__ + "static/media/ChronicleSSm-Book_Web.74cb85c2.woff";